'use client';
'use strict';

var classes = {"root":"m-bf2d988c","inner":"m-26062bec","input":"m-26063560","icon":"m-bf295423","input--outline":"m-215c4542"};

module.exports = classes;
//# sourceMappingURL=Checkbox.module.css.cjs.map
